import React, { useCallback, useEffect, useMemo, useState } from 'react'

import { Popover, Steps, Typography } from 'antd'
import _ from 'lodash'

import './FillingSteps.less'

export const FillingSteps = ({ actionName, fieldGroups, formValues }) => {
  const [completedGroups, setCompletedGroups] = useState({})

  const requiredGroups = useMemo(() => {
    const result = new Map()

    fieldGroups?.forEach(([groupName, { isGroup, fields }]) => {
      if (isGroup && fields.some(({ requiredField }) => requiredField)) {
        const requiredFields = fields.reduce((acc, { requiredField, internalFieldName }) => {
          if (requiredField) acc.push(internalFieldName)
          return acc
        }, [])

        result.set(groupName, requiredFields)
      }
    })

    return result
  }, [fieldGroups])

  useEffect(
    function checkCompletedGroups() {
      const completedGroups = {}
      let isCurrentStep = true

      requiredGroups.forEach((requiredFields, groupName) => {
        const isGroupCompleted = requiredFields.every((fieldName) => formValues[fieldName])
        if (isCurrentStep && !isGroupCompleted) {
          completedGroups[groupName] = 'process'
          isCurrentStep = false
        } else {
          completedGroups[groupName] = isGroupCompleted ? 'finish' : 'wait'
        }
      })

      setCompletedGroups(completedGroups)
    },
    [requiredGroups, formValues]
  )

  const focusGroup = useCallback((groupName) => {
    const groupElement = document.getElementById(`key_${groupName}`)
    if (groupElement) {
      const clickableElement = groupElement.querySelector('.ant-collapse-header')
      const isGroupExpanded = clickableElement?.getAttribute('aria-expanded') === 'true'
      if (clickableElement && !isGroupExpanded) {
        clickableElement.click()
      }

      // Delay is needed for correct scrolling
      _.delay(() => {
        clickableElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }, 300)
    }
  }, [])

  const hasRequiredGroups = useMemo(() => requiredGroups.size > 1, [requiredGroups?.size])

  return (
    <div className="FillingSteps">
      <div>
        <Typography.Text
          className={hasRequiredGroups ? 'FillingSteps__actionTitle' : 'FillingSteps__actionTitleWithoutSteps'}
        >{`${actionName}`}</Typography.Text>

        {hasRequiredGroups && (
          <Steps className="FillingSteps__steps">
            {Array.from(requiredGroups.keys()).map((groupName) => (
              <Steps.Step
                className="FillingSteps__step"
                onClick={() => focusGroup(groupName)}
                status={completedGroups[groupName]}
                key={groupName}
                title={
                  <Popover overlayClassName="FillingSteps__stepPopoverContent" content={groupName} placement="topLeft">
                    {groupName}
                  </Popover>
                }
              />
            ))}
          </Steps>
        )}
      </div>
    </div>
  )
}
